import React from 'react';
import { useSetModalState } from '../../hooks/actions/useModalState';
import { ModalToggleState } from '../../models/actionStates';
import { ifEnter } from '../../util';
import styles from './ZoomWrapper.module.scss';

export const ZoomWrapper: React.FC<{ src: string; width?: string | number; height?: string | number }> = ({ src, children, width, height }) => {
  const setModal = useSetModalState();

  const zoom = () => {
    setModal({
      contents: <img src={src} alt="Zoomed View" style={{ maxWidth: '100%', maxHeight: '100%' }} />,
      height: 'auto',
      width: 'auto',
      maxWidth: '100vw',
      maxHeight: 'unset',
      toggleState: ModalToggleState.Open,
      scrollToTop: false,
      isBaseState: true,
      tapToClose: true,
    });
  };

  return (
    <div role="button" className={styles.zoomContainer} tabIndex={0} onClick={zoom} onKeyDown={(event) => ifEnter(event, zoom)} aria-label="Zoom">
      {children}
    </div>
  );
};

export default ZoomWrapper;
